import Title from "antd/es/typography/Title"
import Structure from "../Structure"
import { Card, Col, Divider, Row } from 'antd';
import { useState } from "react";
import CrearNuevoCampoPersonalizado from "./crear";
import ButtonGroup from "antd/es/button/button-group";
import ListadoCategoriasCargo from "./listado";

const CategoriasCargo = (props) => {
    const {
        tipo,
        titulo
    } = props
    const [ condicion_busqueda, setCondicionBusqueda ] = useState({ tipo })
    const titular = titulo ? titulo : "Categorías"

    const render = () => {
        return <div>
            <Card>
            <Title className="mb-2 mt-0">{titular}</Title>
            <ButtonGroup>
            <CrearNuevoCampoPersonalizado tipo={tipo} onCreate={() => setCondicionBusqueda(prev => ({...{}, ...condicion_busqueda}))} />
            </ButtonGroup>
            <Divider />
                <ListadoCategoriasCargo tipo={tipo} condicion_default={condicion_busqueda} />
            </Card>
        </div>
    }
    
    return <Structure component={render()} />
}

export default CategoriasCargo